import { parseStatic } from '@core/utils/assets.utils'
import { StaticOrientation } from '@core/enums/statics.enum'
import { ComparableMetric, ListedMetric, MetricRequest } from '@core/models/metric.models'
import { Match } from '@core/models/match.models'
import { MetricDetailSubHeader } from '@features/metric-detail/models/metric-detail.models'
import { PLACEHOLDER_IMAGES } from '@mediacoach/ui'

export const parseMatchToMetricDetailRequest = (
  context: Match,
  value: ListedMetric | ComparableMetric
): MetricRequest => ({
  matchId: context.id,
  metricKey: value.key
})

export const parseMatchMetricDetailSubHeader = (metricContext: Match): MetricDetailSubHeader => ({
  imageA: parseStatic(metricContext.homeTeam?.statics, StaticOrientation.Portrait),
  textA: metricContext.homeTeam?.shortName,
  imageB: parseStatic(metricContext.awayTeam?.statics, StaticOrientation.Portrait),
  textB: metricContext.awayTeam?.shortName,
  placeholderA: PLACEHOLDER_IMAGES.TEAM,
  placeholderB: PLACEHOLDER_IMAGES.TEAM
})
